document.addEventListener('DOMContentLoaded', () => {
    const annualInput = document.getElementById('annualSalary');
    const hoursInput = document.getElementById('hoursPerWeek');
    const weeksInput = document.getElementById('weeksPerYear');
    
    const displayHourly = document.getElementById('hourlyRateDisplay');
    const breakdownAnnual = document.getElementById('breakdownAnnual');
    const breakdownMonthly = document.getElementById('breakdownMonthly');
    const breakdownBiWeekly = document.getElementById('breakdownBiWeekly');
    const breakdownWeekly = document.getElementById('breakdownWeekly');
    const breakdownDaily = document.getElementById('breakdownDaily');

    function formatCurrency(value) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(value);
    }

    function calculate() {
        const annual = parseFloat(annualInput.value) || 0;
        const hours = parseFloat(hoursInput.value) || 0;
        const weeks = parseFloat(weeksInput.value) || 0;
        
        if (annual === 0 || hours === 0 || weeks === 0) {
            displayHourly.textContent = '$0.00';
            breakdownAnnual.textContent = '$0.00';
            breakdownMonthly.textContent = '$0.00';
            breakdownBiWeekly.textContent = '$0.00';
            breakdownWeekly.textContent = '$0.00';
            breakdownDaily.textContent = '$0.00';
            return;
        }

        const totalHoursYear = hours * weeks;
        const hourlyRate = annual / totalHoursYear;
        
        displayHourly.textContent = formatCurrency(hourlyRate);
        breakdownAnnual.textContent = formatCurrency(annual);
        breakdownMonthly.textContent = formatCurrency(annual / 12);
        breakdownBiWeekly.textContent = formatCurrency(annual / 26); // assuming 26 bi-weekly periods
        
        // Use weekly based on the user's weeks definition or standard 52? 
        // Typically, "weekly pay" implies annual / 52.
        breakdownWeekly.textContent = formatCurrency(annual / 52);
        
        // Daily pay based on hours per week / 5 days
        const dailyRate = hourlyRate * (hours / 5);
        breakdownDaily.textContent = formatCurrency(dailyRate);
    }

    [annualInput, hoursInput, weeksInput].forEach(input => {
        input.addEventListener('input', calculate);
    });

    // Initial calculation
    calculate();
});
